import React, { useState } from 'react'
import Navbar from '../../Pages/Navbar/JobSeekerNavbar'
import './FAQs.css'
import Footer from '../../Footer/Footer'

function FAQs() {
  const [activeIndex, setActiveIndex] = useState(null)

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  const faqs = [
    {
      category: "For Job Seekers",
      questions: [
        {
          question: "How do I create and optimize my profile?",
          answer: "To create a profile, sign up as a job seeker and complete all required fields including your work experience, education, skills, and upload a professional resume. For optimization, make sure to include relevant keywords, a professional photo, and detailed descriptions of your accomplishments."
        },
        {
          question: "How can I apply for jobs?",
          answer: "Browse through available job listings and click the 'Apply' button on jobs that match your profile. You can apply using your uploaded resume or through our quick apply feature for faster applications."
        },
        {
          question: "Can I track my job applications?",
          answer: "Yes, you can track all your applications in the 'My Applications' section of your dashboard. You'll see the status of each application (submitted, viewed, shortlisted, rejected)."
        }
      ]
    },
    {
      category: "For Employers",
      questions: [
        {
          question: "How do I post a job opening?",
          answer: "After registering as an employer, go to your dashboard and click 'Post a Job'. Fill in the job details, requirements, and preferences. Your job posting will be reviewed and activated within 24 hours."
        },
        {
          question: "How can I search for suitable candidates?",
          answer: "Use our advanced search feature to filter candidates by skills, experience, education, location, and other criteria. You can also set up alerts for new candidates matching your requirements."
        },
        {
          question: "What are the pricing plans for employers?",
          answer: "We offer various subscription plans including Basic (free with limited features), Premium (unlimited job postings and advanced search), and Enterprise (custom solutions for large organizations)."
        }
      ]
    },
    {
      category: "Agency Services",
      questions: [
        {
          question: "How can recruitment agencies partner with the platform?",
          answer: "Agencies can apply for partnership through our agency registration portal. Once approved, you'll get access to bulk candidate management, client management tools, and specialized reporting features."
        },
        {
          question: "What tools are available for agencies?",
          answer: "Agency accounts include candidate pooling, client relationship management, bulk messaging, interview scheduling, and performance analytics to help streamline your recruitment process."
        }
      ]
    },
    {
      category: "Account & Administration",
      questions: [
        {
          question: "How do I reset my password?",
          answer: "Click on 'Forgot Password' on the login page and enter your registered email address. You'll receive a password reset link via email within a few minutes."
        },
        {
          question: "How can I delete my account?",
          answer: "Go to Account Settings > Privacy & Security and click 'Delete Account'. Note that this action is permanent and cannot be undone."
        },
        {
          question: "Who should I contact for technical support?",
          answer: "For technical issues, please contact our support team at support@jobplatform.com or use the live chat feature available during business hours (9 AM - 6 PM, Monday to Friday)."
        }
      ]
    }
  ]

  return (
    <>
      <Navbar/>
      <div style={{marginTop: '70px', padding: '20px', textAlign: 'justify'}}>
        <div className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about our job platform</p>
        </div>
        
        <div className="faq-container">
          {faqs.map((category, categoryIndex) => (
            <div key={categoryIndex} className="faq-category">
              <h2 className="category-title">{category.category}</h2>
              <div className="accordion">
                {category.questions.map((item, index) => {
                  const faqIndex = `${categoryIndex}-${index}`
                  return (
                    <div key={faqIndex} className="accordion-item">
                      <div 
                        className={`accordion-header ${activeIndex === faqIndex ? 'active' : ''}`}
                        onClick={() => toggleAccordion(faqIndex)}
                      >
                        <span className="accordion-question">{item.question}</span>
                        <span className="accordion-icon">
                          {activeIndex === faqIndex ? '−' : '+'}
                        </span>
                      </div>
                      <div 
                        className={`accordion-content ${activeIndex === faqIndex ? 'active' : ''}`}
                      >
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer/>
    </>
  )
}

export default FAQs